import { render } from "./Rider.vue?vue&type=template&id=32fc22ac&scoped=true"
import script from "./Rider.vue?vue&type=script&lang=js"
export * from "./Rider.vue?vue&type=script&lang=js"

import "./Rider.vue?vue&type=style&index=0&id=32fc22ac&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fc22ac"]])

export default __exports__